import { render, staticRenderFns } from "./CompanySeries.vue?vue&type=template&id=29d01146&scoped=true"
import script from "./CompanySeries.vue?vue&type=script&lang=ts"
export * from "./CompanySeries.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d01146",
  null
  
)

export default component.exports